import _ from 'lodash';

function calculateInvoiceAmounts(invoice) {
  const transactions = invoice.lines.filter((line) => _.isNumber(line.amount));

  const linesSubtotal = _.round(_.sumBy(transactions, 'amount'), 2);
  const discountPercent =
    invoice.discountMethod === 'amount'
      ? invoice.discountAmount / linesSubtotal
      : (invoice.discountPercentage || 0) / 100;
  const discountRatio = 1 - discountPercent;

  const nonTaxableSubtotal = _.round(
    _(transactions)
      .filter((line) => !line.taxable)
      .sumBy((line) => line.amount * discountRatio),
    2,
  );

  const taxableSubtotal = _.round(
    _(transactions)
      .filter((line) => line.taxable)
      .sumBy((line) => line.amount * discountRatio),
    2,
  );

  const tax = _.round(
    _(transactions)
      .filter((line) => line.taxable)
      .sumBy((line) => line.amount * discountRatio * ((invoice.taxRate || 0) / 100)),
    2,
  );

  const total = _.round(linesSubtotal * discountRatio + tax, 2);

  const discountAmount = _.round(linesSubtotal * (1 - discountRatio), 2);

  return {
    nonTaxableSubtotal,
    taxableSubtotal,
    linesSubtotal,
    discountAmount,
    tax,
    total,
  };
}

export default calculateInvoiceAmounts;
